var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.dataArray),function(item,index){return _c('div',{key:index,staticClass:"item_menu",class:{ back_ground_avoid: index == 0 || index == 2 },on:{"click":function($event){return _vm.menuCkicked(index)}}},[_c('div',{staticClass:"item_label",class:{
        selected_item: _vm.curentSelectIndex === index,
        back_ground_avoid: index == 0 || index == 2
      }},[_vm._v(" "+_vm._s(item)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }